// 存放Local Storage键值
export const ACCESS_TOKEN = 'Access-Token'
export const USER_INFO = 'uesr_info'
export const PANES_CACHE = 'panes_cache'
export const PANES_HISTORY_CACHE = 'panes_history_cache'
export const MENUS_ACTIVE_ID_CACHE = 'menus_active_id_cache'
export const ACTIVE_KEY_CACHE = 'active_key_cache'
export const REFERRER = 'referrer'
export const LANGUAGE = 'language'
export const SYSTEM_CODE = 'system_code'
export const HOME_MENU_ID = 'home_menu_id'
export const STORE_AUTHORIZATION_NO_DISPLAY = 'store_authorization_no_display'
